import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';

/**
 * Radix tooltip — replaces native SVG `<title>`-only hover hints.
 * Trigger children must accept a forwarded ref (native elements or
 * ui/ components, which all use forwardRef).
 */
interface Props {
  readonly content: ReactNode;
  readonly children: ReactNode;
  readonly side?: 'top' | 'bottom' | 'left' | 'right';
  readonly delayMs?: number;
}

export function Tooltip({ content, children, side = 'top', delayMs = 300 }: Props): JSX.Element {
  return (
    <TooltipPrimitive.Provider delayDuration={delayMs}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            sideOffset={6}
            className="z-50 max-w-xs rounded border border-line bg-raised px-2.5 py-1.5 text-micro text-paper-mid shadow-raised animate-overlay-in"
          >
            {content}
            <TooltipPrimitive.Arrow className="fill-raised" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
